module.exports = __webpack_public_path__ + "media/images/pro_tag-9e9c7f20.svg";